import Navbar from './components/Navbar';
import Hero from './components/Hero';
import CategoryGrid from './components/CategoryGrid';
import Authority from './components/Authority';
import ArticleCards from './components/ArticleCards';
import CTASection from './components/CTASection';
import Testimonial from './components/Testimonial';
import Footer from './components/Footer';

const WEBSITE_SCHEMA = JSON.stringify({
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'OOPBUY Spreadsheet',
  url: 'https://oopbuyspread.top',
  description: 'Die beste Übersicht für günstige Produkte aus China – OOPBUY Spreadsheet Listen mit Sneakers, Kleidung, Elektronik und mehr.',
  inLanguage: 'de',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://oopbuyspread.top/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
});

export default function Home() {
  return (
    <>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: WEBSITE_SCHEMA }} />
      <main>
        <Navbar />
        <Hero />
        <CategoryGrid />
        <Authority />
        <ArticleCards />
        <CTASection />
        <Testimonial />
        <Footer />
      </main>
    </>
  );
}